import Keycloak from 'keycloak-js';
import { configApi } from './config';

const authInstance = new Keycloak(configApi.keycloack);

export default authInstance;
